<template>
  <div id="artist-agreement" class="container">
    <!-- HEADER -->
    <section class="pt-lg-5 py-4">
      <div class="row">
        <div class="col-12">
          <section-header title="Artist Agreement" subtitle="Art Grab" />
        </div>
      </div>
    </section>

    <div class="row content-section">
      <div class="col-md-12">
        <p>
          By uploading your image/s you are acknowledging that you are in agreement with our Terms of Service and Artist Agreement (below).
        </p>
        <p>
          <ol>
            <li>You (The Artist) confirm this Content has not been licensed* to any other parties.</li>
            <li>You, not us (Art Grab, LLC), are responsible for any content you make available through Artgrab.co.</li>
            <li>You have obtained all rights needed to make the Content available for licensing. Someone else's work, copyrighted Content, and stock images found on other platforms are examples of Content prohibited on Art Grab.</li>
            <li>The Artist must complete all fields and aspects of the Artist Dashboard, including, but not limited to, ARTIST PROFILE, LICENSE DETAILS, and PAYOUT METHOD. https://myportal.artgrab.co/</li>
            <li>You confirm the Content does not infringe or violate the rights of any person or entity, and you shall indemnify and hold Art Grab, LLC harmless from any loss, damages, or expenses arising from or related to any claims to the contrary.</li>
            <li>Uploading AI-Generated Content on Art Grab - Any content created, in part or entirely, using artificial intelligence must be marked with the category "AI-Generated" by The Artist during the upload process and follow all other Terms of Service and the Artist Agreement.</li>
            <li>The Artist confirms AI-Generated Content on Art Grab did not utilize the prompt "...in the style of [another artist's name]."</li>
            <li>Uploading AI-Generated Content you created by personally training a machine on another artist's style is prohibited.</li>
            <li>When Content is licensed, exclusive rights will belong to the party that purchases the Content (Licensee), and the Content will no longer be available on Artgrab.co or directly through you. In the case of a Term Licensing event, the Content can be made available again once the Term License has expired.</li>
            <li>Should Content be licensed on Artgrab.co you grant Licensee the unrestricted right to use and exploit the Content for any purpose, in any media, worldwide.</li>
            <li>Art Grab, LLC reserves the right to change our pricing model and/or commission structure at any time and conduct promotional activity, including but not limited to platform-wide sales and promotions.</li>
            <li>Art Grab, LLC reserves the right to remove any content without notice.</li>
            <li>No content associated with hate speech, bullying, child pornography or violence shall be uploaded.</li>
            <li>Please reach out if you have any questions about the Art Grab, LLC "Artist Agreement," selling on the platform, exclusive licensing, or anything else.</li>
          </ol>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { SectionHeader } from "../../components";
const artgrabURL = process.env.VUE_APP_ARTGRAB_URL;

export default {
  name: "artist-agreement-page",
  metaInfo() {
    return {
      title: "Artist Agreement - Art Grab",
      meta: [
        { vmid: "twitter:card", name: "twitter:card", content:`summary_large_image` },
        { vmid: "twitter:title", name: "twitter:title", content:`Artist Agreement - Art Grab` },
        { vmid: "twitter:description", name: "twitter:description", content:`By uploading your image/s you are acknowledging that you are in agreement with our Terms of Service and Artist Agreement.` },
        { vmid: "twitter:image", name: "twitter:image", content: "https://i.imgur.com/gp9AfzO.jpeg" },
        { vmid: "og:url", property: "og:url", content:`https://artgrab.co/artistagreement` },
        { vmid: "og:title", property: "og:title", content:`Artist Agreement - Art Grab` },
        { vmid: "og:description", property: "og:description", content:`By uploading your image/s you are acknowledging that you are in agreement with our Terms of Service and Artist Agreement.` },
        { vmid: "og:image", property: "og:image", content: "https://i.imgur.com/gp9AfzO.jpeg" },
        { vmid: "description", name: "description", content: "By uploading your image/s you are acknowledging that you are in agreement with our Terms of Service and Artist Agreement."}
      ],
      link: [{ rel: "canonical", href: `${artgrabURL}/artistagreement` }],
    }
  },
  components: {
    SectionHeader
  },
  mounted() {
    this.$store.commit("setLayout", "page-layout");
  }
};
</script>

<style scoped lang="scss">
#artist-agreement {
  padding-top: 100px;
  padding-bottom: 80px;

  h2 {
    margin-bottom: 0.5rem;
  }

  .content-section {
    margin-bottom: 2rem;

    ul {
      list-style: disc;

      li:not(last-child) {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
